/*
 * @Author: Branton
 * @Date: 2025-10-28 17:01:49
 * @LastEditTime: 2025-10-28 17:44:10
 * @LastEditors: Branton
 * @Description:
 * @FilePath: \Rms-Tender-Frontend\src\components\loading\loading.tsx
 * 暂无
 */
import { Spin, SpinProps } from 'antd';
import React, { Component } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { useOverlay } from './overlay/index';

interface LoadingProps extends SpinProps {}

let container: HTMLElement | null = null;
let rootInstance: Root | null = null;

class Loading extends Component<LoadingProps> {
  static displayName = 'Loading';
  static show: (config?: LoadingProps | string) => void;
  static hide: () => void;
  // eslint-disable-next-line @typescript-eslint/space-before-function-paren
  render(): React.ReactElement<LoadingProps> {
    return <Spin {...this.props}></Spin>;
  }
}

const clear = (): void => {
  if (container && rootInstance) {
    rootInstance.unmount(); // container 还在，render的div没了
    rootInstance = null;
    container.remove();
    container = null;
  }
};

const addInstance = (): void => {
  clear();
  container = useOverlay('loading-container', {
    center: true
  });
  if (container) {
    rootInstance = createRoot(container);
    rootInstance.render(
      <Loading>
        <span></span>
      </Loading>
    );
  }
};

Loading.show = () => {
  // const trueProps = typeof props === 'string' ? { tip: props } : props;
  addInstance();
};

Loading.hide = () => {
  clear();
};

export { Loading };

export type { LoadingProps };
